import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/approval/state-success.png'
import _imports_1 from '@/assets/approval/state-fail.png'
import _imports_2 from '@/assets/approval/state-pending.png'


const _hoisted_1 = { class: "approval" }
const _hoisted_2 = { class: "approval-box" }
const _hoisted_3 = {
  key: 0,
  class: "state-icon",
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  class: "state-icon",
  src: _imports_1
}
const _hoisted_5 = {
  key: 2,
  class: "state-icon",
  src: _imports_2
}
const _hoisted_6 = {
  key: 3,
  class: "state-icon"
}
const _hoisted_7 = { class: "flow-node" }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "user-list" }
const _hoisted_10 = { class: "user" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "name" }
const _hoisted_13 = {
  key: 0,
  class: "position"
}
const _hoisted_14 = {
  key: 0,
  class: "remarks"
}
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "section" }
const _hoisted_18 = { class: "section" }
const _hoisted_19 = { class: "preset-remarks" }
const _hoisted_20 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: _ctx.approvalInfo.createUserName ? `${_ctx.approvalInfo.createUserName}提交的${_ctx.approvalInfo.type === 200 ? '预支单' : '发薪单'}` : '审批详情',
    modelValue: _ctx.isApprovalPopup,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isApprovalPopup) = $event)),
    size: "880px",
    "custom-class": "custom-drawer",
    "before-close": _ctx.onCloseApproval,
    "append-to-body": false
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_scrollbar, null, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "审批进程", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_timeline, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flowNodeList, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_timeline_item, {
                      class: _normalizeClass([item.state === 1 && 'success ']),
                      key: index
                    }, {
                      dot: _withCtx(() => [
                        (item.state === 1)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                          : (item.state === 2)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                            : (!item.state && _ctx.approvalInfo.flow === index)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                              : (_openBlock(), _createElementBlock("div", _hoisted_6))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(item.createTime), 1),
                          _createVNode(_component_el_card, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "status",
                                style: _normalizeStyle({ color: _ctx.translateStateColor(item.state, index) })
                              }, _toDisplayString(item.stateName || _ctx.translateState(item.state, index)), 5),
                              _createElementVNode("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.approvalInformations, (user, idx) => {
                                  return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("img", {
                                      src: user.userHeadUrl,
                                      alt: "",
                                      class: "avatar"
                                    }, null, 8, _hoisted_11),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("text", _hoisted_12, _toDisplayString(user.userName), 1),
                                      (user.position)
                                        ? (_openBlock(), _createElementBlock("text", _hoisted_13, "(" + _toDisplayString(user.position) + ")", 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 256))
                              ]),
                              (item.auditContent)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label" }, "备注：", -1)),
                                    _createElementVNode("div", _hoisted_15, _toDisplayString(item.auditContent), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider, {
          direction: "vertical",
          style: {"height":"100%"}
        }),
        _createVNode(_component_el_scrollbar, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.approvalInfo.projectName), 1),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_descriptions, {
                column: 1,
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "基本信息" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.approvalInfo.createUserName) + "提交的" + _toDisplayString(_ctx.approvalInfo.type === 200 ? '预支单' : '发薪单'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "审批状态" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.approvalInfo.currentState), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "申请时间" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.approvalInfo.createTime), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "转账人数" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.approvalInfo.peopleNum), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "转账金额" }, {
                    default: _withCtx(() => [
                      _createTextVNode("￥" + _toDisplayString(_ctx.approvalInfo.totalMoney), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "所属企业" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.approvalInfo.serveCompanyName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "申请事由" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.approvalInfo.remarks), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "流程单号" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.approvalInfo.flowCode), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            (_ctx.approvalInfo.state === _ctx.flowStateEnum.progress && _ctx.waitForMe && !_ctx.approvalInfo.isEnd)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "我的待办", -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_form, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "审批操作" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _ctx.approvalForm.isAgree,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.approvalForm.isAgree) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.isAgreeOptions, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_radio, {
                                    key: item.value,
                                    label: item.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "审批意见",
                          prop: "auditContent"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.approvalForm.auditContent,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.approvalForm.auditContent) = $event)),
                              maxlength: 9999,
                              type: "textarea",
                              placeholder: _ctx.approvalForm.isAgree === 1 ? '请输入审批意见，直接提交默认备注同意。' : '请输入驳回原因，直接提交默认备注驳回。'
                            }, null, 8, ["modelValue", "placeholder"]),
                            _createElementVNode("div", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvalForm.isAgree === 1 ? _ctx.presetConfirmRemark : _ctx.presetRefuseRemark, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_tag, {
                                  key: item,
                                  style: {"cursor":"pointer"},
                                  type: "info",
                                  onClick: ($event: any) => (_ctx.approvalForm.auditContent = item)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])), [
        [_directive_loading, _ctx.loading]
      ]),
      _createElementVNode("div", _hoisted_20, [
        (_ctx.approvalInfo.isEnd && _ctx.waitForMe)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              title: "提示：为保护账户安全，请您去手机端审批！",
              closable: false,
              type: "error",
              "show-icon": ""
            }))
          : (_ctx.approvalInfo.state === _ctx.flowStateEnum.progress && !_ctx.waitForMe && _ctx.applyForMe)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                onClick: _ctx.onCancelApply
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("取消申请")
                ])),
                _: 1
              }, 8, ["onClick"]))
            : (_ctx.approvalInfo.state === _ctx.flowStateEnum.progress && _ctx.waitForMe)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_el_button, { onClick: _ctx.onCloseApproval }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("取消")
                    ])),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.onDefineApproval
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("确认")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close"]))
}